// themes.ts
import type { Theme } from "./theme";
import { productionTheme } from "./productionTheme";

export const themes: Record<string, Theme | {}> = {
  production: productionTheme, // renamed from "default"

  summer: {
    background: "#fff7e6",
    headerBg: "#ffe0b3",
    headerTransparency: 0.95,
    fontH1: "#222222",
    fontH2: "#222222",
    fontH3: "#222222",
    fontBody: "#555555",
    buttonBg: "#ffb366",
    buttonText: "#ffff0f",
    buttonHoverBg: "#ff9933",
    tabActiveBg: "#ffb366",
    tabActiveText: "#ffffff",
    tabInactiveBg: "#fff0cc",
    tabInactiveText: "#555555",
    navBaseBg: "#ffffff",
    navBgOpacity: 0.85,
    navPatternImage: "",        // leave empty = no pattern
    navPatternSize: 40,         // 1–100; interpreted as %
    navPatternRepeat: "repeat",
  },

  spring: {
    background: "#e6fff0",
    headerBg: "#b3ffcc",
    headerTransparency: 0.95,
    fontH1: "#222222",
    fontH2: "#222222",
    fontH3: "#222222",
    fontBody: "#555555",
    buttonBg: "#667f99",
    buttonText: "#ffff6f",
    buttonHoverBg: "#337f66",
    tabActiveBg: "#66f699",
    tabActiveText: "#ff7fff",
    tabInactiveBg: "#ccafeb",
    tabInactiveText: "#554555",
    navBaseBg: "#ffffff",
    navBgOpacity: 0.85,
    navPatternImage: "",        // leave empty = no pattern
    navPatternSize: 40,         // 1–100; interpreted as %
    navPatternRepeat: "repeat",
  },

  fall: {
    background: "#fff0e6",
    headerBg: "#ffccb3",
    headerTransparency: 0.95,
    fontH1: "#222222",
    fontH2: "#222222",
    fontH3: "#222222",
    fontBody: "#555555",
    buttonBg: "#ff9966",
    buttonText: "#ffffff",
    buttonHoverBg: "#ff6633",
    tabActiveBg: "#ff9966",
    tabActiveText: "#ffffff",
    tabInactiveBg: "#ffe0cc",
    tabInactiveText: "#555555",
    navBaseBg: "#ffffff",
    navBgOpacity: 0.85,
    navPatternImage: "",        // leave empty = no pattern
    navPatternSize: 40,         // 1–100; interpreted as %
    navPatternRepeat: "repeat",
  },

  winter: {
    background: "#e6f0ff",
    headerBg: "#b3ccff",
    headerTransparency: 0.95,
    fontH1: "#222222",
    fontH2: "#222222",
    fontH3: "#222222",
    fontBody: "#555555",
    buttonBg: "#6699ff",
    buttonText: "#ffffff",
    buttonHoverBg: "#3366ff",
    tabActiveBg: "#6699ff",
    tabActiveText: "#ffffff",
    tabInactiveBg: "#cce0ff",
    tabInactiveText: "#555555",
    navBaseBg: "#ffffff",
    navBgOpacity: 0.85,
    navPatternImage: "",        // leave empty = no pattern
    navPatternSize: 40,         // 1–100; interpreted as %
    navPatternRepeat: "repeat",
  },

  seasonal: {}, // empty → fallback to productionTheme
};
